import './App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { gapi } from 'gapi-script';

import powerPlug from './power.png';

const API_KEY   = 'AIzaSyCegSLOE9L9U8YFcXqjqRmxqju34qlwPgw';
const CALENDAR_ID = 'vrl9r2ine58vfbc49t1bi2fi87h1isbq@import.calendar.google.com';
const DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'];
const CLIENT_ID = '184506638392-6b5i9gqu20qtvocnvlsbdoprc664qfed.apps.googleusercontent.com';
const SCOPE = 'https://www.googleapis.com/auth/calendar';

const config = {
  clientId: CLIENT_ID,
  apiKey: API_KEY,
  scope: SCOPE,
  discoveryDocs: DISCOVERY_DOCS,
};

const days = [
    'Söndag',
    'Måndag',
    'Tisdag',
    'Onsdag',
    'Torsdag',
    'Fredag',
    'Lördag'
];

const PRICE_CHEAP = 0.60;
const PRICE_NORMAL = 1.00;
const PRICE_EXPENSIVE = 1.50;

var cSunrise = "xx:xx";
var cSunset = "xx:xx";

function getSwe(degrees) {
  if (degrees > 348.75 || degrees < 11.25)
    return 'N';		
  else if (degrees >= 11.25 && degrees < 33.75)
    return 'NNÖ';
  else if (degrees >= 33.75 && degrees < 56.25)
    return 'NÖ';
  else if (degrees >= 56.25 && degrees < 78.75)
    return 'ÖNÖ';
  else if (degrees >= 78.75 && degrees < 101.25)
    return 'Ö';
  else if (degrees >= 101.25 && degrees < 123.75)
    return 'ÖSÖ';
  else if (degrees >= 123.75 && degrees < 146.25)
    return 'SÖ';
  else if (degrees >= 146.25 && degrees < 168.75)
    return 'SSÖ';
  else if (degrees >= 168.75 && degrees < 191.25)
    return 'S';
  else if (degrees >= 191.25 && degrees < 213.75)
    return 'SSV';
  else if (degrees >= 213.75 && degrees < 236.25)
    return 'SV';
  else if (degrees >= 236.25 && degrees < 258.75)
    return 'VSV';
  else if (degrees >= 258.75 && degrees < 281.25)
    return 'V';
  else if (degrees >= 281.25 && degrees < 303.75)
    return 'VNV';
  else if (degrees >= 303.75 && degrees < 326.25)
    return 'NV';
  else if (degrees >= 326.25 && degrees < 348.75)
    return 'NNV';
  else
    return 'ERR';
}	

function pad(n) {
  return n < 10 ? "0" + n : n;
}

function convertTo24Hour(timestamp) {
  var date = new Date(timestamp * 1000);

  return pad(date.getHours()) + ':' + pad(date.getMinutes());
}

function getWeatherIcon(id) {

  if (id == 800 || id == 801)
    return "clear-day";

  if (id == 802 || id == 803)
    return "partly-cloudy-day";

  if (id == 804)
    return "cloudy";
      
  id = ~~(id / 100);
    
  if (id == 7)
    return "fog";

  if (id == 6)
    return "snow";
    
  if (id == 5)
    return "rain";
    
  if (id == 3)
    return "drizzle";
    
  if (id == 2)
    return "thunder";
}

function getDateWeek(date) {
  const currentDate = 
      (typeof date === 'object') ? date : new Date();
  const januaryFirst = 
      new Date(currentDate.getFullYear(), 0, 1);
  const daysToNextMonday = 
      (januaryFirst.getDay() === 1) ? 0 : 
      (7 - januaryFirst.getDay()) % 7;
  const nextMonday = 
      new Date(currentDate.getFullYear(), 0, 
      januaryFirst.getDate() + daysToNextMonday);

  return (currentDate < nextMonday) ? 52 : 
  (currentDate > nextMonday ? Math.ceil(
  (currentDate - nextMonday) / (24 * 3600 * 1000) / 7) : 1);
}

function Today() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 60*60*1000);

    return () => clearInterval(interval);
  }, []);

  return (<div className="background">{time.getDate()}</div>)
}

function TimeStamp() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 30000);

    return () => clearInterval(interval);
  }, []);  

  return (<div className="timestamp">{time.toLocaleTimeString().substring(0, 5) + ", v. " + getDateWeek(time)}</div>)
}

function Sunrise() {
  return (<div className="sunrise"><span className="strong">7</span>{cSunrise}</div>);  
}

function Sunset() {
  return (<div className="sunset"><span className="strong">8</span>{cSunset}</div>);  
}

function UpcomingEvents() {
  var eventDate;
  var nowDate = new Date();
  var tomorrowDate = new Date();
  var todayHeaderAdded = false;
  var tomorrowHeaderAdded = false;
  var fridayHeaderAdded = false;
  var saturdayHeaderAdded = false;
  var sundayHeaderAdded = false;
  const [events, setEvents] = useState([]);
  const [rerender, setRerender] = useState(0);

  tomorrowDate.setDate(nowDate.getDate()+1);
  
  useEffect(() => {

    const forceRerender = () => setRerender(c => c + 1);

    // Once every 55 minutes
    const timerId = setInterval(forceRerender, 3300000);

    // All events one week forward
    function loadEvents() {
      var d = new Date();
      var aWeekForwardDate = new Date(d.getFullYear(), d.getMonth(), d.getDate()+7);    

      gapi.client.init(
        config
      ).then(function() {
        return gapi.client.calendar.events.list({
          'calendarId': CALENDAR_ID,
          'singleEvents': true,      
          'timeMin': (new Date()).toISOString(),
          'timeMax': aWeekForwardDate.toISOString(),
          'orderBy': 'startTime'
        });
      }).then(function(response) {
        setEvents(response.result.items);
      }, function(reason) {
        console.log('Error: ', reason);
      });
    }

    gapi.load('client', loadEvents);
    
    return () => {
      clearInterval(timerId);
    };    

  }, [rerender]);

  // Build event list
  let eventList = events.map(function(event) {
    var description = event.summary;
    var location = '';
    var hm = '';  
    var dayHeader = '';
    var showRow = true;
    var today = false;
    var tomorrow = false;

    if (event.location != undefined) {
      location = event.location;
      if (location.toLowerCase().startsWith("http"))
        location = "(digitalt)"
    }

    if (event.start != undefined) {
      if (event.start.dateTime != undefined) {
        eventDate = new Date(event.start.dateTime);
        hm = pad(eventDate.getHours(), 2) + ":" + pad(eventDate.getMinutes(), 2);
      }
      else {
        eventDate = new Date(event.start.date);
        hm = '';
      }
    }

    today = nowDate.getDate() === eventDate.getDate();
    tomorrow = tomorrowDate.getDate() === eventDate.getDate();

    if (today) {
      if (!todayHeaderAdded) {
        dayHeader = <div className="header">Idag</div>
        todayHeaderAdded = true;  
      }
    }
    else if (tomorrow) {
      if (!todayHeaderAdded) {
        dayHeader = <><div className="header">Idag</div><div className='row'>Zzzzz...</div><div className="header">I morgon</div></>
        todayHeaderAdded = true;
        tomorrowHeaderAdded = true;
      }
      else if (!tomorrowHeaderAdded) {
        dayHeader = <div className="header">I morgon</div>
        tomorrowHeaderAdded = true;
      }
    }
    else if (eventDate.getDay() == 5) { // Fredag
      if (!todayHeaderAdded) {
        dayHeader = <><div className="header">Idag</div><div className='row'>Zzzzz...</div></>
        todayHeaderAdded = true;
      }

      if (!tomorrowHeaderAdded) {
        dayHeader = <><div className="header">I morgon</div><div className='row'>Zzzzz...</div></>
        tomorrowHeaderAdded = true;
      }

      if (!fridayHeaderAdded) {
        dayHeader = <div className="header">Fredag</div>
        fridayHeaderAdded = true;
      }
    }
    else if (eventDate.getDay() == 6 && (!today && !tomorrow)) { // Lördag
      if (!saturdayHeaderAdded) {
        dayHeader = <div className="header weekend">Lördag</div>
        saturdayHeaderAdded = true;
      }
    }
    else if (eventDate.getDay() == 0 && (!today && !tomorrow)) { // Söndag
      if (!sundayHeaderAdded) {
        dayHeader = <div className="header weekend">Söndag</div>
        sundayHeaderAdded = true;
      }
    }
    else 
      showRow = false;

    if (showRow)
      return (
        <div key={event.id}>
          {dayHeader}
          <div className='row'>
            <>{hm != '' ? (<span style={{color: 'rgb(120,120,120)'}}> {hm} </span>) : ""}
            {description}
            {location != '' ? (<span style={{color: 'rgb(180,180,180)'}}><small>, {location}</small></span>) : ""}</>
          </div>
        </div>
      )
  });  

  return (
    <span className="event-list">
      {eventList}
    </span>
  );
}

function DrawWeather() {
  var nowDate = new Date();
  const [weather, setWeather] = useState([]);
  const [rerender, setRerender] = useState(0);

  useEffect(() => {
    const forceRerender = () => setRerender(c => c + 1);

    // Once every hour
    const timerId = setInterval(forceRerender, 3600000);

    const fetchWeatherData = async () => {
      const response = await axios.get('https://api.openweathermap.org/data/3.0/onecall?lat=55.7099803&lon=13.3686299&exclude=minutely,hourly&lang=sv&units=metric&appid=e1e3b1934e18b2b82302959d600f6d81');

      cSunrise = convertTo24Hour(response.data.daily[0].sunrise);
      cSunset = convertTo24Hour(response.data.daily[0].sunset);

      setWeather(response.data);

    };

    fetchWeatherData();

    return () => {
      clearInterval(timerId);
    };

  }, [rerender]);

  return weather.length == 0 ? 
  (
    <div className="container">
      <div className="box">
        Laddar...
      </div>
    </div>      
  )
  :
  (
    <div className="container">
      <div className="box">
        <p>Idag<br/><i className={'icon-'+getWeatherIcon(weather.daily[0].weather[0].id)}></i><br/><b>{Math.trunc(weather.current.temp) + '°'}</b><br/><small>{Math.trunc(weather.current.wind_speed) + ' m/s ' + getSwe(weather.current.wind_deg).toLowerCase()}</small></p>
        <p>{days[(nowDate.getDay()+1) % 7]}<br/><i className={'icon-' + getWeatherIcon(weather.daily[1].weather[0].id)}></i><br/><b>{Math.trunc(weather.daily[1].temp.night) + '°-' + Math.trunc(weather.daily[1].temp.day) + '°'}</b></p>
        <p className="last">{days[(nowDate.getDay()+2) % 7]}<br/><i className={'icon-' + getWeatherIcon(weather.daily[2].weather[0].id)}></i><br/><b>{Math.trunc(weather.daily[2].temp.night) + '°-' + Math.trunc(weather.daily[2].temp.day) + '°'}</b></p>
      </div>
      <Sunrise/>
      <Sunset/>
    </div>
  )

}

function DrawElectricityPrices() {
  const [prices, setPrices] = useState([]);
  const [rerender, setRerender] = useState(0);
  const d = new Date();  

  function getPrice(p) {
    if (p <= PRICE_CHEAP)
      return <b className='cheap'>{p}</b>;
    else if (p <= PRICE_NORMAL)
      return <b className='midpriced'>{p}</b>;      
    else
      return <b className='expensive'>{p}</b>;    
  }

  useEffect(() => {
    const forceRerender = () => setRerender(c => c + 1);

    // Once every 5 minutes
    const timerId = setInterval(forceRerender, 30000);

    const getPrices = async () => {
      var p = [];
      const hourNow = d.getHours();
      const year = d.getFullYear();
      const month = d.getMonth() + 1;
      const monthWithLeadingZero = month.toString().padStart(2, '0');    
      const day = d.getDate();
      const dayWithLeadingZero = day.toString().padStart(2, '0');
      const url = 'https://www.elprisetjustnu.se/api/v1/prices/' + year + '/' + monthWithLeadingZero + '-' + dayWithLeadingZero + '_SE4.json';
    
      try {
          const response = await axios.get(url);

          for (const key in response.data) {

            const timePeriod = new Date(response.data[key]['time_start']).getHours();

            if (timePeriod == hourNow) {
                p[0] = response.data[key]['SEK_per_kWh'].toFixed(2);
                p[1] = timePeriod;

                p[2] = response.data[Number(key)+1]['SEK_per_kWh'].toFixed(2);
                p[3] = new Date(response.data[Number(key)+1]['time_start']).getHours();

                p[4] = response.data[Number(key)+2]['SEK_per_kWh'].toFixed(2);
                p[5] = new Date(response.data[Number(key)+2]['time_start']).getHours();

                break; // We found "now", dont look further
            }
          }    

          setPrices(p);

      } catch (err) {
          console.error(err);
      }
    }

    getPrices();

    return () => {
      clearInterval(timerId);
    }

  }, [rerender]);

  
  return prices.length == 0 ? "" : (
    <div className="container_electricity">
      <div className="box_e">
        <p>Nu<br/><img className="pushdown" src={powerPlug}></img><br/>{getPrice(prices[0])}</p>
        <p>{prices[3]+':00'}<br/><img className="pushdown" src={powerPlug}></img><br/>{getPrice(prices[2])}</p>
        <p className="last">{prices[5]+':00'}<br/><img className="pushdown" src={powerPlug}></img><br/>{getPrice(prices[4])}</p>
      </div>
    </div>
  )
}

function App() {

  return (
    <>
      <UpcomingEvents/>
      <DrawWeather/>
      <DrawElectricityPrices/>
      <Today/>
      <TimeStamp/>
    </>
  );
}

export default App;